import { render } from "./Comparacao.vue?vue&type=template&id=4daa7e18&scoped=true"
import script from "./Comparacao.vue?vue&type=script&lang=js"
export * from "./Comparacao.vue?vue&type=script&lang=js"

import "./Comparacao.vue?vue&type=style&index=0&id=4daa7e18&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4daa7e18"]])

export default __exports__